import i18n from 'i18next';
import dayjs from 'dayjs';
import isoDuration from 'dayjs/plugin/duration';
import { RenewalStatusEnum } from './SubscriptionsConstants';

dayjs.extend(isoDuration);

const parseDuration = (duration) => {
  if (Number.isNaN(duration)) {
    return dayjs.duration(Number(duration)).asMilliseconds();
  }
  return dayjs.duration(duration).asMilliseconds();
};

export const capitalize = (string) => string
  .trim()
  .split(' ')
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
  .join(' ');

export const calculateDurationInDays = (product) => {
  const { expiration } = product.exchange;

  if (!expiration) {
    return 0;
  }

  const duration = expiration.replace('cumulative:', '');
  const ms = parseDuration(duration);

  const totalDays = ms / (1000 * 60 * 60 * 24);
  return Math.round(totalDays);
};

export const calculateDurationInMonths = (product) => {
  const totalDays = calculateDurationInDays(product);
  const estimatedMonths = totalDays / 30;
  return Math.round(estimatedMonths);
};

export const calculatePriceInMonth = (product) => {
  const totalPrice = product.purchase.price || 0;
  const months = calculateDurationInMonths(product);
  if (months > 0) {
    return totalPrice / months;
  }
  return totalPrice;
};

export const calculateDurationAsText = (product, t) => {
  const totalDays = calculateDurationInDays(product);
  const totalMonths = calculateDurationInMonths(product);

  if (totalDays < 30) {
    return `${totalDays} ${t('days')}`;
  }

  return `${totalMonths} ${t('months')}`;
};

export const getFormattedSubscriptionPrice = (product) => {
  const formatter = new Intl.NumberFormat(i18n.language, {
    style: 'currency',
    currency: product.purchase.currency.toUpperCase(),
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const priceInMonth = calculatePriceInMonth(product);
  return `${formatter.format(priceInMonth)}/mo`;
};

export const getFormattedSubscriptionTotalPrice = (product) => {
  const formatter = new Intl.NumberFormat(i18n.language, {
    style: 'currency',
    currency: product.purchase.currency.toUpperCase(),
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return formatter.format(product.purchase.price);
};

export const getFormattedSubscriptionTitle = (subscription) => {
  const title = subscription.subscriptionSku
    .replace('subscriptions:', '')
    .replace(':', ' ')
    .replace(/premium standard/i, 'premium');
  return capitalize(title);
};

export const isRenewing = (status) => [
  RenewalStatusEnum.ACTIVE,
  RenewalStatusEnum.ACTION_NEEDED,
].includes(status);

export const isPendingPayment = (status) => [
  RenewalStatusEnum.ACTION_NEEDED,
].includes(status);
